import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json'; // or ar.json for Arabic
countries.registerLocale(enLocale); 

const AddAddress = ({ token }) => {
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    county: '',
    postcode: '',
    street: '',
    building: '',
    floor: '',
    apartment: '',
    phone_number: '',
    note: '',
    isDefault: true,
    with_logo: true,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [postcodeError, setPostcodeError] = useState(''); // Error message for postcode validation
  const [geolocation, setGeolocation] = useState({ latitude: '', longitude: '' }); // Geolocation data
  const countryOptions = Object.entries(countries.getNames('en')).map(([code, name]) => ({
    value: name,
    label: name,
  }));

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

    // Validate and fetch postcode details
    const handlePostcodeLookup = async () => {
      const postcode = formData.postcode.trim();
      if (!postcode) {
        if (formData.county === "United Kingdom") {
          setPostcodeError("Postcode is required for United Kingdom.");
        } else {
          setPostcodeError(""); // Clear for non-UK
        }
        return;
      }
    
      try {
        const response = await axios.get(`https://api.postcodes.io/postcodes/${postcode}`);
        if (response.data.status === 200) {
          const { latitude, longitude, admin_district, country } = response.data.result;
          setGeolocation({ latitude, longitude });
          setFormData((prevData) => ({
            ...prevData,
            city: admin_district,
            county: country,
          }));
          setPostcodeError("");
        } else {
          if (formData.county === "United Kingdom") {
            setPostcodeError("Invalid postcode. Please check and try again.");
          }
        }
      } catch (err) {
        if (formData.county === "United Kingdom") {
          setPostcodeError("Please provide a valid zipcode in UK.");
        }
      }
    };
    useEffect(() => {
      if (!formData.postcode.trim()) return;
    
      const delay = setTimeout(() => {
        handlePostcodeLookup();
      }, 800); 
    
      return () => clearTimeout(delay); 
    }, [formData.postcode]);
  
    useEffect(() => {
      if (formData.county === "United Kingdom" && formData.postcode.trim()) {
        const delay = setTimeout(() => {
          handlePostcodeLookup();
        }, 800);
    
        return () => clearTimeout(delay);
      }
    }, [formData.postcode, formData.county]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setShowPopup(false);
  
    const requestBody = {
      name: formData.name,
      country: formData.county,
      city: formData.city,
      postcode: formData.postcode,
      street:  " ",
      building: formData.building,
      floor: " ",
      apartment: formData.apartment,
      phone_number: formData.phone_number,
      note: formData.note,
      is_default: formData.isDefault,
      with_logo: formData.with_logo,
    };
  
    try {
      const response = await axios.post(
        'https://backend.printtrio.co.uk/api/profile/add-address',
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
  
      if (response.data.success) {
        setShowPopup(true);
        setFormData({
          name: '',
          city: '',
          county: '',
          postcode: '',
          street: '',
          building: '',
          floor: '',
          apartment: '',
          phone_number: '',
          note: '',
          isDefault: false,
          with_logo: true,
        });
      } else {
        setError('Failed to add the address. Please try again.');
      }
    } catch (err) {
      setError('An error occurred while adding the address.');
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[5%]">
    <div className="p-8 bg-white">
      <h2 className="text-xl font-bold mb-6">Add Address</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {success && <p className="text-green-500 mb-4">{success}</p>}

      <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name / Company<span className="text-red-500">*</span></label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name address"
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>
           </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
            <label htmlFor="building" className="block text-sm font-medium text-gray-700">Address Line 1<span className="text-red-500">*</span></label>
            <input
              type="text"
              id="building"
              name="building"
              value={formData.building}
              onChange={handleChange}
              required
              placeholder="Building/House number and street name"
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>

{/* <div>
  <label htmlFor="floor" className="block text-sm font-medium text-gray-700">Floor<span className="text-red-500">*</span></label>
  <input
    type="text"
    id="floor"
    name="floor"
    value={formData.floor}
    onChange={handleChange}
    required
    placeholder="Enter floor number"
    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
  />
</div> */}
<div>
  <label htmlFor="apartment" className="block text-sm font-medium text-gray-700">Address Line 2</label>
  <input
    type="text"
    id="apartment"
    name="apartment"
    value={formData.apartment}
    onChange={handleChange}
    placeholder="Apartment, suite, unit, building, floor (optional)"
    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
  />
</div>

</div>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <label htmlFor="city" className="block text-sm font-medium text-gray-700">City<span className="text-red-500">*</span></label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
              placeholder="Enter your city"
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>
          <div>
            <label htmlFor="county" className="block text-sm font-medium text-gray-700">County</label>
            <input
              type="text"
              id="county"
              name="county"
              value={formData.county}
              onChange={handleChange}
              placeholder="Enter your county"
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>


     
     </div>
      
       
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                    <div>
            <label htmlFor="postcode" className="block text-sm font-medium text-gray-700">Postcode<span className="text-red-500">*</span></label>
            <input
              type="text"
              id="postcode"
              name="postcode"
              value={formData.postcode}
              onChange={handleChange}
              onBlur={() => {
                if (formData.county === "United Kingdom") {
                  handlePostcodeLookup();
                }
              }}
              required
              placeholder="Enter your postcode"
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
             {postcodeError && <p className="text-red-500 text-sm mt-1">{postcodeError}</p>}
          </div>
          <div>
  <label htmlFor="country" className="block text-sm font-medium text-gray-700">
    Country <span className="text-red-500">*</span>
  </label>
  <div className="mt-1 border border-gray-300 rounded-md w-full">
    <Select
      inputId="country"
      options={countryOptions}
      value={countryOptions.find(opt => opt.value === formData.county)}
        defaultValue={countryOptions.find(opt => opt.value === "United Kingdom")}
      onChange={(selected) =>
        setFormData((prev) => ({ ...prev, county: selected.value }))
      }
      placeholder="Select Country"
      classNamePrefix="select"
      styles={{
        control: (base) => ({
          ...base,
          border: 'none',
          boxShadow: 'none',
          minHeight: '38px', // same as input height
          paddingTop: '2px',
          paddingBottom: '2px',
        }),
        valueContainer: (base) => ({
          ...base,
          padding: '0 8px',
        }),
        indicatorsContainer: (base) => ({
          ...base,
          paddingRight: '8px',
        }),
        placeholder: (base) => ({
          ...base,
          textAlign: 'left',
          color: '#9CA3AF', // Tailwind gray-400
        }),
        singleValue: (base) => ({
          ...base,
          textAlign: 'left',
        }),
        input: (base) => ({
          ...base,
          textAlign: 'left',
        }),
      }}
    />
  </div>
</div>



          {/* <div>
            <label htmlFor="street" className="block text-sm font-medium text-gray-700">Street<span className="text-red-500">*</span></label>
            <input
              type="text"
              id="street"
              name="street"
              value={formData.street}
              onChange={handleChange}
              required
              placeholder="Enter your street name"
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div> */}
          <div>
  <label htmlFor="phone_number" className="block text-sm font-medium text-gray-700">Phone<span className="text-red-500">*</span></label>
  <input
    type="text"
    id="phone_number"
    name="phone_number"
    value={formData.phone_number}
    onChange={handleChange}
    required
    placeholder="Enter your phone number"
    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
  />
</div>
   
        </div>


<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

</div>
        <div className="mt-4">
          <label htmlFor="note" className="block text-sm font-medium text-gray-700">Note</label>
          <textarea
            id="note"
            name="note"
            value={formData.note}
            onChange={handleChange}
            placeholder="Add additional notes (e.g., landmarks, instructions)"
            className="mt-1 block w-full border border-gray-300 rounded-md p-2 h-36"
          ></textarea>
        </div>

        <div className="flex gap-10 items-center mt-8 ">
            <div>
          <input
            type="checkbox"
            id="isDefault"
            name="isDefault"
            checked={formData.isDefault}
            onChange={handleChange}
            className="mr-2 accent-pinkCustom"
          />
          <label htmlFor="isDefault" className="text-sm font-medium text-gray-700">Set as Default Delivery Address</label>
          </div>
          <div>
          <input
            type="checkbox"
            id="with_logo"
            name="with_logo"
            checked={formData.with_logo}
            onChange={handleChange}
            className="mr-2 accent-pinkCustom"
          />
          <label htmlFor="with_logo" className="text-sm font-medium text-gray-700">With Printtrio Logo</label>
          </div>
        </div>

        <div className="mt-12 flex items-center space-x-4">
          <button
            type="submit"
            disabled={isSubmitting}
            className={`bg-[#EC008C] text-white px-6 py-2 rounded-lg hover:bg-pink-600 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
          <button
            type="button"
            className="bg-gray-300 px-6 py-2 rounded-lg hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
    {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-[90%] max-w-md text-center">
            <h2 className="text-xl font-bold mb-4">Success!</h2>
            <p className="text-gray-700 mb-6">The address has been added successfully!</p>
            <button
              onClick={() => setShowPopup(false)}
              className="bg-[#EC008C] text-white px-6 py-2 rounded-lg hover:bg-pink-600"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddAddress;
